import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { redirect } from '../../src/browser';
import { WSJ_EDUCATION_URL } from '../../src/constants';
import { SuccessResponse, VerificationService } from '@sheerid/jslib';

interface ReturnToWSJButtonComponentProps {
    verificationService: VerificationService;
}

const ReturnToWSJButtonComponent = ({ verificationService }: ReturnToWSJButtonComponentProps) => {

const verificationId = (verificationService.verificationResponse as SuccessResponse).verificationId || '';

    return (
        <button
            type="button"
            className="sid-btn sid-btn--dark"
            aria-label="submit"
            onClick={() => {
                redirect(`${WSJ_EDUCATION_URL}${verificationId}`)
            }}
            onKeyPress={() => {
                redirect(`${WSJ_EDUCATION_URL}${verificationId}`)
            }}
            tabIndex={0}
        >
            <FormattedHTMLMessage id="returnToWSJ" defaultMessage="CONTINUE" />
        </button>
    );
};

export { ReturnToWSJButtonComponent };
